import { BACKEND_URL } from '../config';
import Cookies from 'universal-cookie';

export const getUsers = async () => {
  const cookies = new Cookies()
  const token = cookies.get('token')

  if (!token) {
    return Promise.reject('Failed to get response from backend');
  }

  const response = await fetch('/api/users', {
      method: 'GET',
      headers: {
          Authorization: token, 
      },
      credentials: 'include'
      });

  const data = await response.json();
  
  if (data) {
    return data;
  }

  return Promise.reject('Failed to get response from backend');
};
